import React, { useState } from "react";
import { Radio, Select } from "antd";

import None from "./None";
import Raw from "./Raw";
import FormData from "./FormData";
import FormUrl from "./FormUrl";

const Body = ({ updateData, data }) => {
  const [value, setValue] = useState(1);
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState("JSON");
  const options = [
    { value: "JSON", label: "JSON" },
    { value: "Text", label: "Text" },
  ];

  const onChange = ({ target }) => {
    const value = target.value;
    setVisible(false);
    if (value === 4) {
      setVisible(true);
    }
    setValue(value);
    const newdata = data.map((param, index) => {
      if (value === 1) {
        param.selected = index == 0 ? true : false;
      } else if (index === value - 1) {
        param.selected = true;
      } else {
        param.selected = index == 0 ? true : false;
      }
      return param;
    });
    updateData(newdata);
  };
  const handleChange = (value) => {
    setType(value);
  };
  return (
    <div style={{ textAlign: "left" }}>
      <Radio.Group
        value={value}
        defaultValue={1}
        onChange={onChange}
        style={{
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <Radio value={1}> none </Radio>
        <Radio value={2}>form-data</Radio>
        <Radio value={3}>x-www-form-urlencoded</Radio>
        <Radio value={4}>raw </Radio>
        {visible && (
          <Select
            bordered={false}
            defaultValue={type}
            style={{ margin: "0", padding: "0" }}
            onChange={handleChange}
            options={options}
          />
        )}
      </Radio.Group>
      {value === 1 ? (
        <None />
      ) : value === 2 ? (
        <FormData updateData={updateData} data={data} />
      ) : value === 3 ? (
        <FormUrl updateData={updateData} data={data} />
      ) : (
        <Raw type={type} updateData={updateData} data={data} />
      )}
    </div>
  );
};
export default Body;
